import * as DofCore from '@ixit/dof-core';
// Mirror main.ts: expose @ixit/dof-core to externally-built plugin bundles.
// The Map is already shared via globalThis (see item-renderer-registry.ts),
// but external plugins need the namespace handle to call register*.
(globalThis as any).__IxitDofCore = DofCore;

// Bare specifiers — vite/rollup resolves through hoisted Client/node_modules.
// Earlier `../node_modules/...` relative paths broke when adding new workspaces
// caused npm to re-hoist deps out of dof-designer's own node_modules. The
// package-root specifier is the ESM entry and registers every UUI custom
// element on first import.
//
// UUI 2 (required by @umbraco-cms/backoffice 17.6) folded the separate
// `@umbraco-ui/uui-css` package into `@umbraco-ui/uui/themes/*` — one
// self-contained `:root` block per theme, carrying the tokens, the @font-face
// rules and the .uui-font/.uui-text classes the two old files used to split.
// LIGHT is the faithful replacement: UUI 1 gated its dark tokens on
// `:root[data-theme='dark']`, an attribute nothing ever set on this page (the
// preview paints its own dark palette on the component host — see
// configurator-preview-base). Importing dark.css here would flip the page
// unconditionally instead.
import '@umbraco-ui/uui/themes/light.css';
import '@umbraco-ui/uui';
import './components/configurator-preview-standalone.js';
